import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { catchError, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';

import type { DevFlagsMap } from '../types';
import { DevFlag } from '../types';

@Injectable({ providedIn: 'root' })
export class DevFlagsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetch(): Observable<DevFlagsMap> {
    return this.httpApi.get('/features').pipe(
      map(({ features }) =>
        Object.values(DevFlag).reduce(
          (acc, value) => {
            acc[value] = (features || []).includes(value);
            return acc;
          },
          <DevFlagsMap>{},
        ),
      ),
      catchError(error => {
        console.error(error);
        const fallbackMap = Object.values(DevFlag).reduce(
          (acc, value) => {
            acc[value] = false;
            return acc;
          },
          <DevFlagsMap>{},
        );
        return of(fallbackMap);
      }),
    );
  }
}
